import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import { AuthProvider } from "./auth.jsx";
import "./styles.css";

const canonicalPagesHost = "pliego-estudiantes.pages.dev";
const isCloudflarePreview = import.meta.env.PROD
  && window.location.hostname.endsWith(`.${canonicalPagesHost}`)
  && window.location.hostname !== canonicalPagesHost;

if (isCloudflarePreview) {
  window.location.replace(`https://${canonicalPagesHost}${window.location.pathname}${window.location.search}${window.location.hash}`);
} else {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}
